/// <amd-module name="Search/Wiki/NavigationHandler" />

import { ActionCreator } from "Search/Wiki/Flux/ActionCreator";
import { areFiltersEqual, deserialize, serializeFilters } from "Search/Shared/Utils";
import { IAggregatedState } from "Search/Wiki/Flux/StoresHub";
import { IVssHistoryService } from "VSS/Platform/History";
import { IVssPageContext } from "VSS/Platform/Context";

export function applyNavigatedUrl(
	actionCreator: ActionCreator,
	rawState: { [key: string]: string },
	aggregateState: IAggregatedState): void {
	const newFilters = deserialize<{ [key: string]: string[] }>(rawState.filters) || {};
	const { searchStoreState } = aggregateState;
	const { query } = searchStoreState;

	let issueNewSearch = rawState.text && query.searchText !== rawState.text;
	issueNewSearch = issueNewSearch || !areFiltersEqual(newFilters, query.filters);
	if (issueNewSearch) {
		actionCreator.performSearch(rawState.text, newFilters);
	}
}

export function updateUrl(pageContext: IVssPageContext, getAggregatedState: () => IAggregatedState): void {
	const historyService = pageContext.getService<IVssHistoryService>("IVssHistoryService");
	const state = historyService.getState();
	const oldFilters = deserialize<{ [key: string]: string[] }>(state.filters) || {};

	const { searchStoreState } = getAggregatedState();
	const { query } = searchStoreState;

	const newParams: { [key: string]: string } = {};
	let addHistoryPoint = false;

	if (state.text !== query.searchText) {
		newParams.text = query.searchText;
		addHistoryPoint = true;
	}

	if (!areFiltersEqual(query.filters, oldFilters)) {
		newParams.filters = serializeFilters(query.filters);
		addHistoryPoint = true;
	}

	if (addHistoryPoint) {
		historyService.pushState({ ...state, ...newParams });
	}
}